<template>
    <v-dialog v-model="showScheduleTimeDialog"
            persistent
            :min-width="$windowWidth < 1200 ? '60%' : (scheduleTimeEditMode ? '70%' : '40%')"
            min-height="80%"
            width="auto">
        <v-card v-if="scheduleTimeJob">
            <v-toolbar theme="dark">
                <v-toolbar-title>{{ scheduleTimeEditMode ? 'Edit Scheduled Time' : 'Schedule Time' }}</v-toolbar-title>
                <v-btn icon="mdi-close"
                       @click="showScheduleTimeDialog = false"></v-btn>
            </v-toolbar>
            <v-card-text>
                <v-row>
                    <v-col :cols="scheduleTimeEditMode ? 8 : 12" :md="scheduleTimeEditMode ? 9 : 12">
                        <v-text-field v-if="!scheduleTimeEditMode"
                                      label="Scheduled Date"
                                      type="date"
                                      density="compact"
                                      :hide-details="true"
                                      v-model="scheduleTimeJob.scheduledDate"></v-text-field>
                        <v-text-field label="Start Time"
                                      type="time"
                                      class="mt-2"
                                      density="compact"
                                      :hide-details="true"
                                      @change="onStartTimeChange"
                                      v-model="scheduleTimeJob.startTime"></v-text-field>
                        <div class="text-caption text-grey-darken-1 mt-1" v-if="calculatedEndTime">
                            Ends at {{ calculatedEndTime }}
                        </div>
                        <v-select label="Line"
                                  v-if="!scheduleTimeEditMode"
                                  density="compact"
                                  class="mt-2"
                                  :hide-details="true"
                                  item-title="text"
                                  item-value="value"
                                  :items="$constants.jobs.lines"
                                  @update:modelValue="onLineChange"
                                  v-model="scheduleTimeJob.line"></v-select>
                        <v-text-field label="Estimated Run Time"
                                      type="number"
                                      class="mt-2"
                                      suffix="hours"
                                      density="compact"
                                      :hide-details="true"
                                      @change="onHoursChange"
                                      v-model.number="scheduleTimeJob.estimatedHours"></v-text-field>
                        <v-select label="Reason"
                                  density="compact"
                                  class="mt-2"
                                  :hide-details="true"
                                  @update:modelValue="onReasonChange"
                                  :items="$constants.jobs.scheduledTimeReasons"
                                  v-model="scheduleTimeJob.reason"></v-select>
                        <v-alert icon="mdi-alert-decagram-outline"
                                 class="my-2"
                                 v-if="!scheduleTimeEditMode && scheduleTimeErrors.length > 0"
                                 type="warning">
                            <ul class="small-text">
                                <li :key="error" v-for="error in scheduleTimeErrors">{{ error }}</li>
                            </ul>
                        </v-alert>
                    </v-col>
                    <v-col cols="4" md="3" class="smart-note-section" v-if="scheduleTimeEditMode">
                        <note-bar></note-bar>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="d-flex justify-end">
                <v-btn v-if="!scheduleTimeEditMode"
                       @click="save"
                       :loading="saving"
                       :disabled="scheduleTimeErrors.length > 0"
                       prepend-icon="mdi-calendar-check"
                       color="success">
                    SAVE
                </v-btn>
                <v-btn variant="tonal" @click="showScheduleTimeDialog = false" :disabled="saving">
                    CLOSE
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<style scoped lang="scss">
    @import '../../../styles/smart.scss'
</style>
<script>
    import { mapActions, mapState } from "vuex";
    function initialState() {
        return {
            saving: false,
        };
    }
    export default {
        name: "SmartScheduleTimeDialog",
        data: function () {
            return initialState();
        },
        mounted: function () {
        },
        props: {
        },
        methods: {
            ...mapActions([
                "showErrorSnack",
                "showSuccessSnack",
                "saveScheduleTime",
                "updateScheduleTimeReason",
                "updateScheduleTimeHours",
                "updateScheduleTimeLine",
                "updateScheduleTimeStart"
            ]),
            reset: function () {
                Object.assign(this.$data, initialState());
            },
            save() {
                this.saving = true;
                this.saveScheduleTime().finally(() => {
                    this.saving = false;
                });
            },
            onReasonChange(value) {
                this.scheduleTimeJob.reason = value;
                if (this.scheduleTimeEditMode) {
                    this.updateScheduleTimeReason();
                }
            },
            onHoursChange() {
                if (this.scheduleTimeEditMode) {
                    this.updateScheduleTimeHours();
                }
            },
            onLineChange(value) {
                this.scheduleTimeJob.line = value;
                if (this.scheduleTimeEditMode) {
                    this.updateScheduleTimeLine();
                }
            },
            onStartTimeChange() {
                if (this.scheduleTimeEditMode) {
                    this.updateScheduleTimeStart();
                }
            },
        },
        computed: {
            ...mapState({
                scheduleTimeJob: (state) => state.smart.scheduleTimeJob,
                scheduleTimeEditMode: (state) => state.smart.scheduleTimeEditMode,
            }),
            showScheduleTimeDialog: {
                get() {
                    return this.$store.state.smart.showScheduleTimeDialog
                },
                set(value) {
                    this.$store.commit('setShowScheduleTimeDialog', value)
                }
            },
            calculatedEndTime() {
                if (!this.scheduleTimeJob || !this.scheduleTimeJob.scheduledDate || !this.scheduleTimeJob.startTime || !this.scheduleTimeJob.estimatedHours) {
                    return null;
                }
                let start = this.$dayjs(this.scheduleTimeJob.scheduledDate + ' ' + this.scheduleTimeJob.startTime);
                if (!start.isValid()) {
                    return null;
                }
                return start.add(parseFloat(this.scheduleTimeJob.estimatedHours) * 60, 'minute').format('h:mm A');
            },
            scheduleTimeErrors() {
                let errors = [];
                if (!this.scheduleTimeJob) {
                    return errors;
                }
                if (!this.scheduleTimeJob.scheduledDate) {
                    errors.push('Scheduled date is required');
                }
                if (!this.scheduleTimeJob.startTime) {
                    errors.push('Start time is required');
                }
                if (!this.scheduleTimeJob.line) {
                    errors.push('Line is required');
                }
                if (!this.scheduleTimeJob.estimatedHours || this.scheduleTimeJob.estimatedHours <= 0) {
                    errors.push('Estimated run time is required');
                }
                if (!this.scheduleTimeJob.reason) {
                    errors.push('Reason is required');
                }
                return errors;
            },
        },
    };
</script>
